import {database} from './fire'
import {ref, update} from "firebase/database"

export default async function saveDataToFirebase(userID, date, data) {
    const dataPath = 'data/' + userID + '/' + date
    return update(ref(database, dataPath), data)
}